export function generateServiceType(name:any,serviceTypeValue:any){
    return jQuery('<div class="form-check">'+
        '<label class="custom-radio-primary" for="input'+name+'">'+
            '<input type="radio" name="chkServiceType" id="input'+name+'"  value="'+serviceTypeValue+'">'+
            '<span class="radio-circle" aria-hidden="true"></span>'+
            '<span class="radio-text">'+name+'</span>'+
        '</label>'+
    '</div>')
}